<template>
  <div class="content-warp">
    <a-row :gutter="24">
      <a-col :span="10">
        <div class="content-panle bg-white">
          <TableTips 
            :title="$t('devicesManaActiveTime.selectedDevices')"
            :total="devicesData.length" 
          />
          <a-table 
            style="min-height: 598px;"
            :columns="devicesColumns"
            :pagination="false"
            :dataSource="devicesData"
          >
            <template slot="operation" slot-scope="text, record">
              <div v-if="record.operation">
                <a 
                  v-for="item in record.operation" 
                  :key="item.type"
                  :disabled="item.disabled"
                  :style="{color: item.color || '#1890ff'}"
                  @click="item.callback(record)"
                >
                  {{$t(item.type)}}
                </a>
              </div>
            </template>
          </a-table>
        </div>
      </a-col>
      <a-col :span="14">
        <div class="content-panle bg-white">
          <TableTips 
            :title="$t('devicesManaActiveTime.selectTimeConfig')"
            :total="pagination.total"
            :selected="selectedRowKeys.length"
            @clearAllSelected="() => {selectedRowKeys = []}"
          />
          <a-table 
            style="min-height: 598px;"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: (rowKeys) => {selectedRowKeys = rowKeys} }"
            :columns="timeConfigsColumns" 
            :dataSource="timeConfigs"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
          ></a-table>
        </div>

        <div style="margin-top: 16px; text-align: right">
          <a-button 
            type="primary" 
            :loading="submitting"
            :disabled="!selectedRowKeys.length || !devicesData.length"
             @click="handleSetValidTimeInfoSubmit"
          >{{$t('devicesManaActiveTime.submitBtn')}}</a-button>
          <a-button 
            :style="{ marginLeft: '8px' }"
            @click="handleBackList"
          >{{$t('devicesManaActiveTime.backBtn')}}</a-button>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { parsePromiseAllRes } from '../../utils/utils';
import { getAllTimeConfig, setDeviceTimeConfig } from '@/api/timeConfig';

import TableTips from '@/components/TableTips';

export default {
  name: 'devicesManaActiveTime',
  components: { TableTips },
  data() {
    return {
      devicesColumns: this.getDevicesColumns(), // 列表表头项
      devicesData: [],

      // 有效时间选择项集合
      loading: false, // 列表内容是否在加载中
      timeConfigs: [], // 列表数据源
      timeConfigsColumns: this.getTimeConfigsColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      selectedRowKeys: [], // 列表多选钩中项的Id数组

      submitting: false
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang: function (lang) {
      this.devicesColumns = this.getDevicesColumns()
      this.timeConfigsColumns = this.getTimeConfigsColumns()
    }
  },  
  beforeCreate() {
    if (!this.$route.query.ds) {
      this.$error({
        title: this.$t('devicesManaActiveTime.pageErrTitle'),
        content: this.$t('devicesManaActiveTime.pageErrContent'),
        okText: this.$t('devicesManaActiveTime.backBtn'),
        onOk: () => {
          this.$router.push({ name: 'devicesManaIndex' });
          setTimeout(() => {
            this.$multiTab.close('/devices-mana/active-time');
          }, 500)
        }
      });
    };
  },
  created() {
    this.getAllValidTimeConfig()
  },
  activated() {    
    if (this.$route.query.ds) {
      this.oldDeviceSources = JSON.parse(this.$route.query.ds)
      this.devicesData = this.oldDeviceSources.map(item => {
        return {
          key: item.id,
          id: item.id,
          name: item.name,
          deptName: item.deptName,
          operation: [{
            type: 'devicesManaActiveTime.listDeviceRemoveBtn',
            disabled: false,
            color: '#f5222d',
            callback: this.handleDeleteDevice
          }]
        }
      });
    }
  },
  methods: {
    // ----------- 设备列表 -----------
    getDevicesColumns() {
      return [
        {
          title: this.$t('devicesManaActiveTime.listDeviceName'),
          dataIndex: 'name',
          width: '30%'
        },
        {
          title: this.$t('devicesManaActiveTime.listDeviceOrg'),
          dataIndex: 'deptName',
          width: '50%'
        },
        {
          title: this.$t('devicesManaActiveTime.listDeviceOperation'),
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    // 移除设备
    handleDeleteDevice(device) {
      let vm = this;
      // console.log('---handleDeleteDevice---', device)
      this.oldDeviceSources = this.oldDeviceSources.filter(item => {
        return item.id !== device.id
      })
      this.$route.query.ds = JSON.stringify(this.oldDeviceSources)
      
      this.devicesData = this.devicesData.filter(item => {
        return item.id !== device.id
      })

      if (this.devicesData.length === 0) {
        this.handleBackList()
      }
    },

    // ----------- 时间配置列表列表 -----------
    getTimeConfigsColumns() {
      return [
        {
          title: this.$t('devicesManaActiveTime.listTimeConfigName'),
          dataIndex: 'name'
        }
      ]
    },
    // 获取所有门禁有效时间
    async getAllValidTimeConfig() {
      try {
        this.loading = true;
        const res = await getAllTimeConfig({
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.loading = false;
        // 设置有效时间选择项
        this.timeConfigs = this.createTimeConfigTableData(res.data.collection)
        this.pagination.total = res.data.size;
      } catch (error) {}
    },
    createTimeConfigTableData(data) {
      return data.map(item => {
        return {
          key: item.id,
          id: item.id,
          name: item.name
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.getAllValidTimeConfig();
    },
    
    // ----------- 提交等操作 -----------    
    // 提交门禁有效期设置
    handleSetValidTimeInfoSubmit() {
      this.submitting = true;
      
      let submitPromises = this.devicesData.map(item => this.submitRquest(item.id, this.selectedRowKeys));

      Promise.all(submitPromises).then(resArr => {
        // 处理 Promise.all 返回结果
        const { successRes } = parsePromiseAllRes(
          this, 
          resArr, 
          {
            successMsg: new Function('count', this.$t('devicesManaActiveTime.batchSetSuccess')),
            failMsg: new Function('count', this.$t('devicesManaActiveTime.batchSetFail')),
            targets: this.devicesData.map(device => { return { id: device.id, name: device.name } })
          }
        )

        if (successRes.length === this.devicesData.length) {
          setTimeout(this.handleBackList(), 2000)
        }           
        this.submitting = false;
      }).catch(err => {
        this.submitting = false;
      })
    },
    // 提交门禁有效期设置的请求
    async submitRquest(deciveId, durationIds) {
      try {
        const res = await setDeviceTimeConfig({
          deviceId: deciveId,
          durationIds: durationIds
        })
        return Promise.resolve({ res: res, targetId: deciveId })
      } catch (error) {
        return Promise.resolve({ res: error, targetId: deciveId })
      }
    },
    // 返回列表
    handleBackList() {
      this.$multiTab.closeCurrentPage();
      this.$router.push({ name: 'devicesManaIndex' });
    }
  }
}
</script>
<style>
.ant-table-body { 
  overflow-y: auto !important;
}
</style>
<style scoped>
.ant-table-body { 
  overflow-y: auto !important;
}
.panle-table-title{
  margin: 0;
  padding: 5px 16px;
  font-size: 16px;
}
.panle-table-title:before{
  content: "";
  margin-right: 10px;
  border: 2px solid #1890ff;
  border-radius: 5px;
}
</style>